import { isNewRecTalent } from "./talentHelpers";
import { ThingToLoad, TrelloBoardTalent } from "~/models/types";

export const getHandleTalentsTipSessionKey = ({
  recruitmentId,
}: {
  recruitmentId: string;
}): string => `HandleTalentsTipOpened|${recruitmentId}`;

export const highlightHandleTalentsTip = ({
  recTalents,
  recruitmentId,
  handleCandidatesTipOpened,
}: {
  recruitmentId: string;
  recTalents: TrelloBoardTalent[];
  handleCandidatesTipOpened: Record<string, boolean>;
}): boolean => {
  const isOpenedBefore = handleCandidatesTipOpened[recruitmentId];
  if (isOpenedBefore) {
    return false;
  }

  return recTalents.some(isNewRecTalent);
};

export const highlightWantMoreCandidatesTips = ({
  recruitmentId,
  wantMoreCandidatesTipsOpened,
}: {
  recruitmentId: string;
  wantMoreCandidatesTipsOpened: Record<string, ThingToLoad<boolean>>;
}): boolean => {
  const isOpenedBefore = wantMoreCandidatesTipsOpened[recruitmentId];

  console.log("isOpenedBefore", isOpenedBefore);

  if (isOpenedBefore === undefined) {
    return true;
  }

  if (isOpenedBefore.type === "loaded") {
    return !isOpenedBefore.value;
  }

  return false;
};
